export const getMaxCountLocal = () => localStorage.getItem('MaxCount');
export const setMaxCountLocal = (maxCount) => localStorage.setItem('MaxCount', maxCount);
export const deleteMAxCountLocal = () => localStorage.setItem('MaxCount', undefined);




 const getTouchCount = (touchCount, listingArray) => {

  const pagination = (allListings) => {
    if(Array.isArray(allListings)){
      const divisor = 5;
      const totalNumberOfListings = allListings.length;
      const stringToNumberTotalListings = Number(totalNumberOfListings);
      const batchNumber = Math.floor(stringToNumberTotalListings/divisor);
      const overflow = stringToNumberTotalListings%divisor;
      let maxCount = batchNumber;
      let range = [];
      if(batchNumber < 1){
        return {
          range,
          maxCount,
          overflow,
          allListings,
        };
        // return stringToNumberTotalListings;
      }else if(batchNumber === 1 && overflow < 1){
          return {
          range,
          maxCount,
          overflow,
          allListings,
        };
        // return stringToNumberTotalListings;
      }else{
        // overflow < 1 ? maxCount : maxCount += 1;
        for(let i=1; i<=maxCount; i++){
          let getSingleRange = [0 +(i-1)*divisor, i*divisor];
          range.push(getSingleRange);
        };
        return {
          range,
          maxCount,
          overflow,
          allListings,
        };
      };
    }else{
      return 'Cannot parse input';
    }; 
  };
  
  const touchCountToNumber = Number(touchCount);
    if(isNaN(touchCountToNumber) || typeof(touchCountToNumber) !== "number"){
      return "Incorrect input";
    }else if(typeof(touchCountToNumber) === "number" && !isNaN(touchCountToNumber) && touchCountToNumber > 0){
        
      const holdRange = pagination(listingArray);
      let {range, maxCount, overflow, allListings} = holdRange;
      if(maxCount === 0){
        return [{
          maxCount,
          listing: allListings,
        }]
      }else if(overflow > 0){
        maxCount += 1;
        if(maxCount - touchCount === 0){
          const getSlicedListing = allListings.slice(-overflow)
          return [{
            maxCount,
            listing:getSlicedListing,
          }]
        }else{
          const getExactRange = range[touchCount -1];
          const getExactSlice = allListings.slice(getExactRange[0], getExactRange[1]);
          return [{
            maxCount,
            listing: getExactSlice,
          }];
        }
      }else if(0 < touchCount <= maxCount){
        const getExactRange = range[touchCount -1];
        const getExactSlice = allListings.slice(getExactRange[0], getExactRange[1]);
        return [{
          maxCount,
          listing: getExactSlice,
        }]
      }else{
        return 'Invalid input. Fatal error';
      };
  
    }else{
      return 'Re-evaluate input';
  };
  
  };

  export default getTouchCount;






                                                            
                                                                                  